import Navbar from "../components/navbar"
import Footer from "../components/footer"
import front_model from '../images/front-model.jpg'
import LoadingOverlay from "../components/loading"
import emptyList from "../components/empty_list"
import { useContext, useEffect, useRef, useState } from "react"
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCart } from "../hooks/add_to_cart"
import { FaTimes } from "react-icons/fa";
import {LiaTimesSolid} from "react-icons/lia";
import { ProductDetails } from "../components/product_details"
import { useCookies } from "react-cookie"
import { useNavigate, useParams } from "react-router-dom"
import { BarLoader } from "react-spinners"
import { PayPalButtons } from "@paypal/react-paypal-js";
import { IoMdCheckmarkCircleOutline } from "react-icons/io"
import { useReactToPrint } from "react-to-print";
import { TostMessageContext } from "../context/TostMessage"

export default function OrderSuccess({ route }) {
    const [pageLoading, setPageLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [featured_prod, setFeaturedProd] = useState([]);
    const [products, setProducts] = useState([]);
    const { addToCart, checkItemInCart, removeItem, convertAmount } = useCart();
    const [showModal, setShowModal] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const [cookies, removeCookie] = useCookies();
    const navigate = useNavigate();
    const [payment, setPayment] = useState("cod");
    const [pageData, setPageData] = useState({});
    const {reference} = useParams();
    const {setTostMessage} = useContext(TostMessageContext)

    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
    });

    useEffect(async () => {
        console.log(reference);
        getData();
        removeCookie("myCart", { path: "/" });

        if (cookies?.billingInfo?.email != undefined) {
            const formData = new FormData();
            formData.append('cart_data', JSON.stringify([]));
            formData.append('customer', cookies?.billingInfo?.email);

            try {
                const response = await axios.post(base_url + '/update_cart.php', formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.data.status) {
                    // return response.data.in_stock;
                } else {
                    // return 'N/A'
                }
            } catch (error) {
                // return 'N/A'
            }
        }
    }, [])

    async function getData() {
        const formData = new FormData();
        formData.append('reference', reference);

        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_order_receipt.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.data.status) {
                setPageData(response.data)
                setTimeout(function () {
                    handlePrint();
                }, 1000)
                setTostMessage({
                    messageType: 'success',
                    message: 'Downloading receipt'
                })
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: 'Unable to load payment info'
                })
            }
            setPageLoading(false)
        } catch (error) {
            setPageLoading(false)
            setTostMessage({
                messageType: 'error',
                message: 'Network error'
            })
        }
    }

    return(
        <div className="w-full h-auto">
            {pageLoading && <LoadingOverlay />}
            <Navbar />
            <div className="max-w-6xl mx-auto px-4 py-6">
                <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
                <div ref={componentRef} className="w-full max-w-2xl rounded-2xl shadow-sm">
                    <div className="p-6 sm:p-8">
                    {/* Header */}
                    <div className="flex flex-col items-center text-center gap-4">
                        <IoMdCheckmarkCircleOutline size={60} className="h-16 w-16 text-teal-600" />
                        <h1 className="text-xl sm:text-2xl font-semibold text-gray-800">
                        Thank you! Your order has been placed.
                        </h1>
                        <p className="text-gray-500 text-sm sm:text-base">
                        Your order <span className="font-medium">#{pageData?.reference}</span> has been confirmed and will be shipped soon.
                        </p>
                    </div>

                    {/* Order Summary */}
                    <div className="mt-8 border rounded-xl p-4 sm:p-6">
                        <h2 className="text-lg font-semibold text-teal-700 mb-4">Order Summary</h2>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                        <div>
                            <p className="text-gray-500">Order Number</p>
                            <p className="font-medium">#{pageData?.reference}</p>
                        </div>
                        <div>
                            <p className="text-gray-500">Order Date</p>
                            <p className="font-medium">{pageData?.time}</p>
                        </div>
                        <div>
                            <p className="text-gray-500">Payment Method</p>
                            <p className="font-medium">Online</p>
                        </div>
                        <div>
                            <p className="text-gray-500">Total Amount</p>
                            <p className="font-semibold text-orange-600">{convertAmount(pageData?.order_amount)}</p>
                        </div>
                        </div>

                        <hr className="my-6" />

                        {/* Items */}
                        <div className="space-y-4">
                            {pageData?.order_items?.map((item, index) => 
                                <Item
                                    name={item.name}
                                    qty={item.qty}
                                    price={convertAmount(item.item_amount)}
                                    img={item.thumbnail}
                                />
                            )}
                        </div>
                    </div>

                    {/* Footer Actions */}
                    <div className="mt-8">
                        <p className="text-teal-700 font-medium mb-4">What's Next?</p>
                        <div className="flex flex-col sm:flex-row gap-4">
                        <button onClick={() => window.open('https://api.whatsapp.com/message/EJMNVMDG22ZTP1?autoload=1&app_absent=0%0A', '_blank')} className="w-full text-white p-2 rounded-sm bg-teal-700 hover:bg-teal-800">
                            Need Help?
                        </button>
                        <button
                            onClick={() => navigate('/shop-now')}
                            variant="outline"
                            className="w-full  p-2 rounded-sm border-orange-700 text-orange-700 hover:bg-orange-50"
                        >
                            Continue Shopping
                        </button>
                        </div>
                        <p className="text-sm text-gray-400 text-center mt-4">
                        A confirmation email has been sent to {pageData?.email}
                        </p>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

function Item({ name, qty, price, img }) {
  return (
    <div className="flex items-center gap-4">
      <img
        src={img}
        alt={name}
        className="h-12 w-12 rounded-md object-cover"
      />
      <div className="flex-1">
        <p className="font-medium text-gray-800">{name}</p>
        <p className="text-sm text-gray-500">Qty: {qty}</p>
      </div>
      <p className="font-medium text-gray-700">{price}</p>
    </div>
  );
}